'use client';

import { findScrollContainer } from '@prismo-io/utils/client/find-scroll-container';
import { useSearchParams } from 'next/navigation';
import { type FC, useEffect, useMemo } from 'react';
type Props = {
  offsetTop?: number;
};
export const AutoScrollToFocusElement: FC<Props> = props => {
  const {
    offsetTop = 0
  } = props;
  const searchParams = useSearchParams();
  const focusTo = useMemo(() => searchParams.get('focus'), [searchParams]);
  useEffect(() => {
    if (!focusTo) {
      return;
    }
    const focusName = focusTo.trim();
    const target = document.querySelector<HTMLElement>(`[data-focus="${focusName}"]`);
    if (!target) {
      return;
    }
    const parent = findScrollContainer(target);
    if (!parent) {
      return;
    }
    const scrollTop = parent.scrollTop + target.getBoundingClientRect().top;
    parent.scrollTo({
      behavior: 'smooth',
      top: scrollTop - offsetTop * 1.1
    });
  }, [focusTo, offsetTop]);
  return null;
};